import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { Button } from '@components';
import { Card, Form, Row, Col } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
    messageError,
    messageToast,
    objectRoles,
    typeError,
    styleSelectError,
    styleSelectDefault,
    GIOI_TINH
} from '../../utils/define';
import { addAccountAction } from '../../store/reducers/account';
import { Get, Post, Put, DeleteSingle } from '../../utils/httpProvider';
import {
    NHAN_VIEN_API,
    DON_VI_API,
    HOC_VI_API,
    CHUC_DANH_KHOA_HOC_API,
    ACCOUNT_API
} from '../../utils/apiUrl';

const schema = yup.object().shape({
    username: yup.string().required(messageError.emptyMessage),
    fullname: yup.string().required(messageError.emptyMessage),
    soCMND_CCCD: yup.string().notRequired().nullable(),
    password: yup
        .string()
        .min(6, messageError.minLength6Message)
        .max(30, messageError.maxLength30Message)
        .required(messageError.emptyMessage),
    roles: yup.array().min(1, messageError.emptyMessage),
    chucDanhKHCaoNhat: yup.string().required(messageError.emptyMessage),
    hocViCaoNhat: yup.string().required(messageError.emptyMessage),
    gioiTinh: yup.string().notRequired().nullable()
});

const AccountAdd = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const [donVis, setDonVis] = useState([]);
    const [hocVis, setHocVis] = useState([]);
    const [chucDanhs, setChucDanhs] = useState([]);

    useEffect(() => {
        const checkActive = (item) => {
            if (!item) return false;
            const val = item.isActive;
            if (val === undefined || val === null) return false;
            const str = String(val).trim().toLowerCase();
            return str !== 'false' && str !== '0' && str !== 'null' && str !== 'undefined';
        };

        Get(DON_VI_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1000 })
            .then(res => {
                if (res && res.data) {
                    setDonVis(res.data.filter(checkActive));
                }
            }).catch(e => console.error(e));
        
        Get(HOC_VI_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1000 })
            .then(res => {
                if (res && res.data) {
                    setHocVis(res.data.filter(checkActive));
                }
            }).catch(e => console.error(e));

        Get(CHUC_DANH_KHOA_HOC_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1000 })
            .then(res => {
                if (res && res.data) {
                    setChucDanhs(res.data.filter(checkActive));
                }
            }).catch(e => console.error(e));
    }, []);

    const handleCreate = async (values, actions) => {
        try {
            // 1. Tạo nhân viên trước
            const nhanVienPayload = {
                hoTen: values.fullname,
                soCMND_CCCD: values.soCMND_CCCD || '',
                dienThoaiDiDong: values.phoneNumber,
                emailCongViec: 'Chưa cập nhật',
                gioiTinh: values.gioiTinh ? Number(values.gioiTinh) : null,
                chucDanhKHCaoNhat: Number(values.chucDanhKHCaoNhat),
                hocViCaoNhat: Number(values.hocViCaoNhat),
                ngaySinh: null,
                chucVu: null,
                donViId: null,
                isActive: 1
            };

            const nvRes = await Post(NHAN_VIEN_API.ADD_ITEM, null, nhanVienPayload, false);
            if (!nvRes || (!nvRes.id && !nvRes.Id)) {
                toast.error("Không khởi tạo được hồ sơ giảng viên/nhân viên!");
                return;
            }

            // 2. Tạo tài khoản đăng nhập
            const roleAccount = values.roles.length > 0 ? values.roles.map((x) => x.value) : [];
            const accountPayload = {
                username: values.username,
                fullname: values.fullname,
                phoneNumber: values.phoneNumber,
                email: 'Chưa cập nhật',
                roles: roleAccount,
                password: values.password,
                confirmPassword: values.password,
                isActive: true
            };

            const result = await dispatch(addAccountAction(accountPayload));
            if (result.payload && result.payload.errors) {
                // Xóa nhân viên vừa tạo để tránh rác DB nếu tạo tài khoản thất bại
                await DeleteSingle(NHAN_VIEN_API.DELETE_ITEM, nvRes.id || nvRes.Id);
                if (result.payload.type === typeError.UserName) {
                    actions.setErrors({
                        username: result.payload.errors.content[0]
                    });
                }
                return;
            }

            if (result.payload === 200) {
                // 3. Truy vấn tài khoản vừa tạo để lấy Guid ID
                const pagingRes = await Get(ACCOUNT_API.GET_PAGING_ACCOUNT, null, {
                    PageIndex: 1,
                    PageSize: 10,
                    Keyword: values.username
                });
                const responseData = pagingRes?.data || pagingRes?.Data;
                const newAccount = responseData?.find(acc => (acc.username || acc.Username || '')?.toLowerCase() === values.username.toLowerCase());
                if (newAccount) {
                    // 4. Cập nhật gắn NhanVienId vào tài khoản
                    const updatePayload = {
                        username: values.username,
                        fullName: values.fullname,
                        email: 'Chưa cập nhật',
                        phoneNumber: values.phoneNumber,
                        isActive: true,
                        roles: roleAccount,
                        nhanVienId: nvRes.id || nvRes.Id
                    };
                    await Put(ACCOUNT_API.EDIT_ACCOUNT, newAccount.id || newAccount.Id, updatePayload);
                }

                toast.success(messageToast.messageToastCreateSuccess);
                history.goBack();
            }
        } catch (error) {
            console.error(error);
            toast.error(messageToast.messageToastTryCatch);
        }
    };

    return (
        <Card className="shadow-sm border-0">
            <Card.Header as="h5" className="bg-primary text-white py-3">Thêm tài khoản mới</Card.Header>
            <Card.Body className="p-4 px-md-5 bg-white">
                <Formik
                    validationSchema={schema}
                    onSubmit={(values, actions) => handleCreate(values, actions)}
                    initialValues={{
                        username: '',
                        fullname: '',
                        soCMND_CCCD: '',
                        phoneNumber: '',
                        password: '',
                        roles: [],
                        chucDanhKHCaoNhat: '',
                        hocViCaoNhat: '',
                        gioiTinh: ''
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        errors,
                        touched,
                        setFieldValue
                    }) => (
                        <Form noValidate onSubmit={handleSubmit} className="premium-form">
                            {/* Hàng 1: Chức danh - Học vị - Giới tính */}
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label className="col-sm-2 col-form-label text-md-end font-weight-bold">
                                    Chức danh:
                                </Form.Label>
                                <Col sm="10">
                                    <div className="d-flex gap-2 flex-wrap flex-md-nowrap">
                                        <div style={{ flex: 1, minWidth: '150px' }}>
                                            <Form.Control
                                                as="select"
                                                name="chucDanhKHCaoNhat"
                                                value={values.chucDanhKHCaoNhat}
                                                onChange={handleChange}
                                                isInvalid={touched.chucDanhKHCaoNhat && !!errors.chucDanhKHCaoNhat}
                                                style={{ height: '40px', borderRadius: '6px' }}
                                            >
                                                <option value="">Chọn chức danh</option>
                                                {chucDanhs.map((o) => (
                                                    <option key={o.id} value={o.id}>
                                                        {o.tenChucDanh}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                        </div>
                                        
                                        <div style={{ flex: 1, minWidth: '150px' }}>
                                            <Form.Control
                                                as="select"
                                                name="hocViCaoNhat"
                                                value={values.hocViCaoNhat}
                                                onChange={handleChange}
                                                isInvalid={touched.hocViCaoNhat && !!errors.hocViCaoNhat}
                                                style={{ height: '40px', borderRadius: '6px' }}
                                            >
                                                <option value="">Chọn TS/TSKH</option>
                                                {hocVis.map((o) => (
                                                    <option key={o.id} value={o.id}>
                                                        {o.tenHocVi}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                        </div>

                                        <div style={{ flex: 1, minWidth: '150px' }}>
                                            <Form.Control
                                                as="select"
                                                name="gioiTinh"
                                                value={values.gioiTinh}
                                                onChange={handleChange}
                                                isInvalid={touched.gioiTinh && !!errors.gioiTinh}
                                                style={{ height: '40px', borderRadius: '6px' }}
                                            >
                                                <option value="">Giới tính</option>
                                                {GIOI_TINH.map((o) => (
                                                    <option key={o.value} value={o.value}>
                                                        {o.label}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                        </div>
                                    </div>
                                    {((touched.chucDanhKHCaoNhat && errors.chucDanhKHCaoNhat) || 
                                       (touched.hocViCaoNhat && errors.hocViCaoNhat)) && (
                                         <div className="text-danger mt-1" style={{ fontSize: '12px' }}>
                                             Vui lòng điền đủ chức danh và học vị
                                         </div>
                                     )}
                                </Col>
                            </Form.Group>

                            {/* Hàng 2: Họ và tên */}
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label className="col-sm-2 col-form-label text-md-end font-weight-bold">
                                    Họ và tên*:
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        type="text"
                                        placeholder="Nhập họ và tên..."
                                        name="fullname"
                                        value={values.fullname}
                                        onChange={handleChange}
                                        isInvalid={touched.fullname && !!errors.fullname}
                                        style={{ height: '40px', borderRadius: '6px' }}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.fullname}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            {/* Hàng 3: Số CMND/CCCD */}
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label className="col-sm-2 col-form-label text-md-end font-weight-bold">
                                    Số CMND/CCCD:
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        type="text"
                                        placeholder="Nhập số CMND hoặc thẻ căn cước..."
                                        name="soCMND_CCCD"
                                        value={values.soCMND_CCCD}
                                        onChange={handleChange}
                                        isInvalid={touched.soCMND_CCCD && !!errors.soCMND_CCCD}
                                        style={{ height: '40px', borderRadius: '6px' }}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.soCMND_CCCD}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            {/* Hàng 4: Username đăng nhập */}
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label className="col-sm-2 col-form-label text-md-end font-weight-bold">
                                    Username đăng nhập*:
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        type="text"
                                        placeholder="Tên đăng nhập hệ thống..."
                                        name="username"
                                        value={values.username}
                                        onChange={handleChange}
                                        isInvalid={touched.username && !!errors.username}
                                        style={{ height: '40px', borderRadius: '6px' }}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.username}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            {/* Hàng 5: Số điện thoại */}
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label className="col-sm-2 col-form-label text-md-end font-weight-bold">
                                    Số điện thoại:
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        type="text"
                                        placeholder="Số điện thoại liên hệ..."
                                        name="phoneNumber"
                                        value={values.phoneNumber}
                                        onChange={handleChange}
                                        style={{ height: '40px', borderRadius: '6px' }}
                                    />
                                </Col>
                            </Form.Group>

                            {/* Hàng 6: Quyền tài khoản */}
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label className="col-sm-2 col-form-label text-md-end font-weight-bold">
                                    Quyền tài khoản*:
                                </Form.Label>
                                <Col sm="10">
                                    <Select
                                        isMulti
                                        name="roles"
                                        id="roles"
                                        placeholder="Chọn quyền cho tài khoản..."
                                        value={values.roles}
                                        onChange={(selectedOption) => {
                                            setFieldValue('roles', selectedOption, true);
                                        }}
                                        options={objectRoles}
                                        styles={
                                            touched.roles && errors.roles !== undefined
                                                ? styleSelectError
                                                : styleSelectDefault
                                        }
                                    />
                                    {touched.roles && errors.roles && (
                                        <div className="text-danger mt-1" style={{ fontSize: '12px' }}>
                                            {errors.roles}
                                        </div>
                                    )}
                                </Col>
                            </Form.Group>

                            {/* Hàng 7: Mật khẩu */}
                            <Form.Group as={Row} className="mb-4 align-items-center">
                                <Form.Label className="col-sm-2 col-form-label text-md-end font-weight-bold">
                                    Mật khẩu*:
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        type="password"
                                        placeholder="Nhập mật khẩu (tối thiểu 6 ký tự)..."
                                        name="password"
                                        value={values.password}
                                        onChange={handleChange}
                                        isInvalid={touched.password && !!errors.password}
                                        style={{ height: '40px', borderRadius: '6px' }}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.password}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            {/* Nút hành động */}
                            <Row className="mt-4 pt-3 border-top">
                                <Col className="text-center">
                                    <Button
                                        type="submit"
                                        theme="primary"
                                        style={{ 
                                            borderRadius: '24px', 
                                            padding: '8px 45px', 
                                            fontWeight: 600,
                                            boxShadow: '0 4px 10px rgba(0, 123, 255, 0.25)' 
                                        }}
                                    >
                                        Tạo tài khoản
                                    </Button>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <Button
                                        onClick={() => history.goBack()}
                                        theme="secondary"
                                        style={{ 
                                            borderRadius: '24px', 
                                            padding: '8px 30px',
                                            fontWeight: 600 
                                        }}
                                    >
                                        Hủy
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </Card.Body>
        </Card>
    );
};

export default AccountAdd;
